(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3501],{

/***/ 23501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Desktop; }
});

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/Footer/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("footer",  true ? {
  target: "e1cnvdru2"
} : 0)("padding:96px 180px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_900;
}, ";" + ( true ? "" : 0))));
var InnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1cnvdru1"
} : 0)( true ? {
  name: "su8agc",
  styles: "width:1080px"
} : 0);
var LinkText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "e1cnvdru0"
} : 0)( true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/Footer/Pairy/index.tsx







var Pairy = function Pairy() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: 'https://salesclue.io',
      passHref: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: "/images/salesclue_logo_white_alpha.png",
          width: 133,
          height: 31,
          priority: true
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("address", {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        as: "p",
        color: "zinc_400",
        variant: "xs-medium",
        marginTop: 16,
        children: ["\uC8FC\uC2DD\uD68C\uC0AC \uB0B4\uB7EC\uD2F0\uBE0C", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uB300\uD45C\uC774\uC0AC: \uAE40\uC778\uAE30", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC0AC\uC5C5\uC790\uBC88\uD638 : 703-88-00878 l \uD1B5\uC2E0\uD310\uB9E4\uC5C5 \uC2E0\uACE0\uBC88\uD638 : \uC81C 2023-\uC11C\uC6B8\uAC15\uB0A8-04677 \uD638", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\uC8FC\uC18C: \uC11C\uC6B8\uD2B9\uBCC4\uC2DC \uC131\uB3D9\uAD6C \uC131\uC218\uC77C\uB85C 10\uAE38 12, 406, 408\uD638 (\uC131\uC218\uB3D92\uAC00, \uC131\uC218\uC528\uC5D0\uD504\uD0C0\uC6CC(\uC131\uC218CF-TOWER))", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "Copyright @ 2025 SalesClue"]
      })
    })]
  });
};

/* harmony default export */ var Footer_Pairy = (Pairy);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/Footer/Sites/index.tsx



var sites = [{
  isInternal: false,
  href: 'https://salesclue.io/blog',
  text: '세일즈클루 블로그'
}, {
  isInternal: false,
  href: 'https://docs.salesclue.io/',
  text: '사용 가이드'
}, {
  isInternal: false,
  href: 'https://codestates.career.greetinghr.com/home',
  text: '채용 정보'
}, {
  isInternal: false,
  href: 'https://codestates.notion.site/salesclue-privacy',
  text: '개인정보 처리 방침'
}, {
  isInternal: false,
  href: 'https://codestates.notion.site/salesclue-policy',
  text: '이용 약관'
}];

var Sites = function Sites() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
    children: sites.map(function (_ref, index) {
      var href = _ref.href,
          text = _ref.text,
          isInternal = _ref.isInternal;

      if (isInternal) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: href,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkText, {
              variant: "sm-medium",
              color: "zinc_200",
              marginTop: index === 0 ? 0 : 16,
              children: text
            })
          })
        }, text);
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
          href: href,
          target: "_blank",
          rel: "noreferrer noopener nofollow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkText, {
            variant: "sm-medium",
            color: "zinc_200",
            marginTop: index === 0 ? 0 : 16,
            children: text
          })
        })
      }, text);
    })
  });
};

/* harmony default export */ var Footer_Sites = (Sites);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/Footer/index.tsx







var Footer = function Footer() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Flex */.kC, {
    justifyContent: "center",
    backgroundColor: "zinc_900",
    padding: {
      y: 96
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnerWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 16,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
          flexGrow: 1,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Pairy, {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* FlexItem */.B5, {
          flexGrow: 1,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_Sites, {})
        })]
      })
    })
  });
};

/* harmony default export */ var Desktop_Footer = (Footer);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e12upvzk1"
} : 0)("width:", function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : '1080px';
}, ";margin:0 auto;" + ( true ? "" : 0));
var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e12upvzk0"
} : 0)( true ? {
  name: "1p3qk0r",
  styles: "&:hover{cursor:pointer;}"
} : 0);
;// CONCATENATED MODULE: ./components/Layouts/Main/Desktop/index.tsx







var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
      className: className,
      fullWidth: fullWidth,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
        justifyContent: "center",
        marginTop: 100,
        onClick: function onClick() {
          window.open('https://salesclue.io', '_blank');
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
          src: "/images/salesclue_logo_white_alpha.png",
          width: 174,
          height: 40
        })
      }), children]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Desktop_Footer, {})]
  });
};

/* harmony default export */ var Desktop = (MainLayout);

/***/ }),

/***/ 94943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || '';

function getDomainLocale(path, locale, locales, domainLocales) {
  if (true) {
    var normalizeLocalePath = (__webpack_require__(92235).normalizeLocalePath);

    var detectDomainLocale = (__webpack_require__(69205).detectDomainLocale);

    var target = locale || normalizeLocalePath(path, locales).detectedLocale;
    var domain = detectDomainLocale(domainLocales, undefined, target);

    if (domain) {
      var proto = "http".concat(domain.http ? '' : 's', "://");
      var finalLocale = target === domain.defaultLocale ? '' : "/".concat(target);
      return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
    }

    return false;
  } else {}
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 94793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(44429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _router = __webpack_require__(32172);

var _addLocale = __webpack_require__(37787);

var _routerContext = __webpack_require__(60950);

var _appRouterContext = __webpack_require__(40177);

var _useIntersection = __webpack_require__(22104);

var _getDomainLocale = __webpack_require__(94943);

var _addBasePath = __webpack_require__(99094); // @ts-ignore useTransition exist


var hasUseTransition = typeof _react["default"].useTransition !== 'undefined';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options)["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, startTransition) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an AppRouterInstance, then it'll have `softPush` and
    // `softReplace`.
    if ('softPush' in router && 'softReplace' in router) {
      // If we're doing a soft navigation, use the soft variants of
      // replace/push.
      var method = soft ? replace ? 'softReplace' : 'softPush' : replace ? 'replace' : 'push';
      router[method](href);
    } else {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    }
  };

  if (startTransition) {
    startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      soft = props.soft,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "soft", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var _ref = hasUseTransition ? // There is no difference between renders in this case, only between using React 18 vs 17.
  // @ts-ignore useTransition exists
  // eslint-disable-next-line react-hooks/rules-of-hooks
  _react["default"].useTransition() : [],
      _ref2 = _slicedToArray(_ref, 2),

  /* isPending */
  startTransition = _ref2[1];

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, soft, shallow, scroll, locale, appRouter ? startTransition : undefined);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 92235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizeLocalePath = void 0;

var normalizeLocalePath = function normalizeLocalePath(pathname, locales) {
  if (true) {
    return (__webpack_require__(49574).normalizeLocalePath)(pathname, locales);
  }

  return {
    pathname: pathname,
    detectedLocale: undefined
  };
};

exports.normalizeLocalePath = normalizeLocalePath;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 40177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

if (false) {}

/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(94793)


/***/ })

}]);